import { connectSettings } from '../Provider/context';
import Head from './Head';


export default connectSettings('settings')(Head);
